<template>
    <v-flex xs12>
        <v-carousel>
            <v-carousel-item
                    v-for="(item,i) in carousel"
                    :key="i"
                    :src="imageUrl + 'gallery/' + item.name"
                    height="100%"
            ></v-carousel-item>
        </v-carousel>
    </v-flex>
</template>

<script>
    import { sync } from 'vuex-pathify';
    const axios = require('axios');

    export default {
        name: 'Carousel',
        data () {
            return {
            }
        },
        computed: {
            ...sync(['carousel', 'serviceUrl', 'serviceEndpoints.GET_CAROUSEL', 'imageUrl']),
        },
        methods: {
        },
        mounted: function () {
            let me = this;
            if ((this.carousel === undefined) || (this.carousel === null)  || (this.carousel.length === 0)) {
                axios.get(this.serviceUrl + this.GET_CAROUSEL)
                    .then(function (response) {
                        me.carousel = response.data.payload;
                    })
                    .catch(function (error) {
                        console.log(error);
                    })
            }
        }
    }
</script>

<style>
</style>
